<template>
    <Header :ueberschrift="this.quiz.name" />
    <div id="quiz">
        <div>
            <center>
                <img class="col-12" id="Bild" ref="Bild" :src="image" v-if="imageActive"><br>
                <input v-if="aenderungsmodus" type="file" id="fileInput">
                <h2 v-if="!aenderungsmodus" id="Frage" ref="Frage">{{ this.aufgaben[this.aktuelleFrage].frage }}</h2>
                <h2>
                    <textarea v-if="aenderungsmodus" maxlength="450" 
                    v-model="this.aufgaben[this.aktuelleFrage].frage"
                    style="font-size: inherit; line-height: inherit; width: 100%; overflow: hidden;" placeholder="Frage"></textarea>
                </h2>
            </center>
        </div>
        <div id="Eingabe">
            <div class="Aufgaben">
                <div v-for="moeglichkeit in this.moeglichkeiten" :key="moeglichkeit.position" :id="'Antwort'+moeglichkeit.position" :ref="'Antwort'+moeglichkeit.position" class="d-flex align-items-center">
                    <span v-if="!aenderungsmodus" id="CheckboxSpan"><input class="col-2" type="checkbox" :id="'checkbox'+moeglichkeit.position" :ref="'checkbox'+moeglichkeit.position"><label class="col-10" :for="'checkbox'+moeglichkeit.position"
                        :id="'label'+moeglichkeit.position" :ref="'label'+moeglichkeit.position">{{ moeglichkeit.text }}</label></span>
                    <span v-if="aenderungsmodus" id="AenderungsSpan">
                        <input class="col-2" type="checkbox" :id="'checkbox'+moeglichkeit.position" :ref="'checkbox'+moeglichkeit.position" :checked="moeglichkeit.richtigFlag == 1">
                        <textarea v-if="aenderungsmodus" maxlength="200" 
                        v-model="moeglichkeit.text"
                        style="font-size: inherit; line-height: inherit; width: 70%; overflow: hidden;" :placeholder="'Antwort '+moeglichkeit.position"></textarea>
                        <button id="moeglichkeitLoeschen" v-if="aenderungsmodus" @click="moeglichkeitLoeschen(moeglichkeit)" class="buttonSubmitNext">Möglichkeit löschen</button>
                    </span>
                </div>
                <button v-if="aenderungsmodus" id="buttonHinzufuegen" @click="moeglichkeitHinzufuegen" class="buttonSubmitNext">Antwort hinzufügen</button>
            </div>
            <span v-if="!aenderungsmodus">
                <button v-if="buttonAbschickenactive" id="buttonAbschicken" ref="buttonAbschicken" @click="checkAnswer" class="buttonSubmitNext">Abschicken</button>
                <button v-if="buttonWeiteractive" id="buttonWeiter" ref="buttonWeiter" @click="next" class="buttonSubmitNext">Nächste Frage</button>
            </span>
            <span v-if="aenderungsmodus">
                <button id="buttonHinzufuegen" @click="frageHinzufuegen" class="buttonSubmitNext">Hinzufügen</button>
                <button id="buttonSpeichern" @click="speichern" class="buttonSubmitNext">Speichern</button>
                <button id="buttonWeiterAenderungsmodus" @click="next" class="buttonSubmitNext">Nächste Frage</button>
            </span>
        </div>
        <br>
        <div class="Aufgabenzahl">
            <center>
                <h3 id="Aufgabe" ref="Aufgabe">Frage: {{ this.aktuelleFrage + 1 }} / {{ this.aufgaben.length }}</h3>
            </center>
        </div>

        <button v-if="this.settingsAvailable" class="Settings fa" @click="this.settings = !this.settings"><h1>&#xf013;</h1></button>

        <span id="settings" v-if="settings">
            <p>Admin:</p>
            <hr>
            <button class="menuButton" @click="this.aenderungsmodus = !this.aenderungsmodus; this.settings = false"><span>Änderungsmodus</span><span class="fa">&#xf105;</span></button>
        </span>
    </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import {ref, onMounted} from 'vue'
import Swal from 'sweetalert2'
import axios from 'axios';
    
export default {
    name: 'MTA2',
    components: {
        Header,
        Footer
    },
    data() {
        return {
            quizID: "",
            quiz: {},
            aufgaben: [{ frage: 'Frage lädt noch oder konnte nicht geladen werden...'}],
            moeglichkeiten: [],
            aktuelleFrage: 0,
            buttonAbschickenactive: true,
            buttonWeiteractive: false,
            falscheAntwort: 0,
            firstStart: true,
            settingsAvailable: false,
            settings: false,
            aenderungsmodus: false,
            image: "",
            imageActive: true,
        }
    },
    methods: {
        clearFileInput(input){
            try{
                input.value = '';
                if(input.value){
                    input.type = "text";
                    input.type = "file";
                }
            }catch(e){}
        },
        async moeglichkeitLoeschen(moeglichkeit){
            var moeglichkeitObj;
            var moeglichkeitArray = [];
            var zaehler = 0;
            this.moeglichkeiten.forEach(obj => {
                if(obj.position == moeglichkeit.position){
                    
                } else{
                    zaehler += 1;
                    moeglichkeitObj = obj;
                    moeglichkeitObj.position = zaehler;
                    moeglichkeitArray[zaehler-1] = moeglichkeitObj;
                }
            });
            await this.deleteMoeglichkeiten(this.aufgaben[this.aktuelleFrage]);
            moeglichkeitArray.forEach(obj => {
                this.createMoeglichkeit(obj);
            });
            this.moeglichkeiten = moeglichkeitArray;
        },
        async moeglichkeitHinzufuegen(){
            var moeglichkeit = {
                    aufgabenID: this.aufgaben[this.aktuelleFrage].aufgabenID,
                    quizID: this.aufgaben[this.aktuelleFrage].quizID,
                    position: this.moeglichkeiten.length + 1,
                    text: "",
                    richtigFlag: 0
                }
                console.log(moeglichkeit);
                this.moeglichkeiten.push(moeglichkeit);
                await this.createMoeglichkeit(moeglichkeit);
        },
        async speichern(){
            var aufgaben = await this.getAufgaben(this.quizID);

            await this.deleteFile(this.aufgaben[this.aktuelleFrage].imagePath);

            var file = document.getElementById("fileInput").files[0];

            const formData = new FormData();
            formData.append('file', file);

            const response = await fetch('https://feuerwehr-server.org:5000/upload-image-endpoint', {
                method: 'POST',
                body: formData
            });

            const result = await response.json(); // der Pfad oder das Ergebnis vom Backend
            var imagePath = "";
            if (result.success) {
                // Wenn der Upload erfolgreich war, Geraet anlegen
                imagePath = result.filePath; // Bildpfad vom Backend
            }

            var aufgabe = {
                quizID: this.aufgaben[this.aktuelleFrage].quizID,
                aufgabenID: this.aufgaben[this.aktuelleFrage].aufgabenID,
                frage: this.aufgaben[this.aktuelleFrage].frage,
                imagePath: imagePath
            }

            var aufgabeErfolgreich = false;
            if(this.aufgaben.length > aufgaben.length){
                aufgabeErfolgreich = await this.createAufgabe(aufgabe);
            } else{
                await this.editAufgabe(aufgabe)
                await this.deleteMoeglichkeiten(aufgabe);
            }

            for(var i = 0; i < this.moeglichkeiten.length; i++){
                var richtigFlag = (document.getElementById('checkbox'+this.moeglichkeiten[i].position).checked)?'1':'0';

                var moeglichkeit = {
                    aufgabenID: aufgabe.aufgabenID,
                    quizID: this.moeglichkeiten[i].quizID,
                    position: this.moeglichkeiten[i].position,
                    text: this.moeglichkeiten[i].text,
                    richtigFlag: richtigFlag
                }
                await this.createMoeglichkeit(moeglichkeit);
            }
        },
        async createAufgabe(aufgabe){
            axios.post('https://feuerwehr-server.org:5000/addAufgabe', aufgabe)
            .then(response => {
                Swal.fire("Änderung erfolgreich gespeichert", "", "success");
                return true;
                // Hier könntest du entsprechende Aktionen ausführen, z.B. Benutzer weiterleiten, eine Erfolgsmeldung anzeigen, etc.
            })
            .catch(error => {
                Swal.fire("Es ist ein Fehler aufgetreten", "Bitte wenden Sie sich an den Administrator", "error");
                console.log(error);
                return false;
                // Hier könntest du Fehlerhandhabung durchführen, z.B. eine Fehlermeldung anzeigen, den Benutzer dazu auffordern, es erneut zu versuchen, etc.
            });
        },
        async editAufgabe(aufgabe){
            try {
                const response = await axios.put('https://feuerwehr-server.org:5000/updateAufgabe', aufgabe);
                Swal.fire("Änderung erfolgreich gespeichert", "", "success");
                console.log(response.data);
            } catch (err) {
                console.error(err);
            }
        },
        async createMoeglichkeit(moeglichkeit){
            axios.post('https://feuerwehr-server.org:5000/addMoeglichkeit', moeglichkeit)
            .then(response => {
                return true;
                // Hier könntest du entsprechende Aktionen ausführen, z.B. Benutzer weiterleiten, eine Erfolgsmeldung anzeigen, etc.
            })
            .catch(error => {
                Swal.fire("Es ist ein Fehler aufgetreten", "Bitte wenden Sie sich an den Administrator", "error");
                return false;
                // Hier könntest du Fehlerhandhabung durchführen, z.B. eine Fehlermeldung anzeigen, den Benutzer dazu auffordern, es erneut zu versuchen, etc.
            });
        },
        async deleteMoeglichkeiten(aufgabe){
            try{
                await axios.delete(
                    'https://feuerwehr-server.org:5000/deleteMoeglichkeiten',
                    { params: { aufgabenID: aufgabe.aufgabenID, quizID: aufgabe.quizID } }
                );
            } catch (err){
                console.log(err);
            };
        },
        async deleteFile(filePath) {
            try {
                const response = await fetch('https://feuerwehr-server.org:5000/delete-image', {
                    method: 'DELETE',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ filePath: filePath }) // Pfad der Datei senden
                });

                const result = await response.json();
                if (result.success) {
                    console.log('Datei erfolgreich gelöscht:', result.message);
                } else {
                    console.error('Fehler beim Löschen der Datei:', result.message);
                }
            } catch (error) {
                console.error('Error:', error);
            }
        },
        frageHinzufuegen(){
            var neueAufgabe = {
                quizID: this.quizID,
                aufgabenID: this.aufgaben.length + 1,
                frage: "",
                imagePath: ""
            }
            this.aufgaben.push(neueAufgabe);
            var moeglichkeiten = [
                {
                    aufgabenID: (this.aufgaben.length - 1),
                    quizID: this.quizID,
                    position: 1,
                    text: "",
                    richtigFlag: 0
                },
                {
                    aufgabenID: (this.aufgaben.length - 1),
                    quizID: this.quizID,
                    position: 2,
                    text: "",
                    richtigFlag: 0
                },
                {
                    aufgabenID: (this.aufgaben.length - 1),
                    quizID: this.quizID,
                    position: 3,
                    text: "",
                    richtigFlag: 0
                },
                {
                    aufgabenID: (this.aufgaben.length - 1),
                    quizID: this.quizID,
                    position: 4,
                    text: "",
                    richtigFlag: 0
                },
            ];
            this.moeglichkeiten = moeglichkeiten;
            this.aktuelleFrage = this.aufgaben.length -1;
        },
        async getQuizID(){
            this.quizID = this.$route.params.quizID.replace(":", "");
            return this.quizID;
        },
        async getQuizByID(quizID){
            var konvKey = this.$route.params.id.replace(":", "");
            try {
                const response = await axios.get(
                'https://feuerwehr-server.org:5000/quizByQuizID',
                { params: { konvKey: konvKey, quizID: quizID } }
                );
                console.log(response.data);
                return response.data;
            } catch (err) {
                console.log(err);
                return false;
            }
        },
        async getAufgaben(quizID){
            var konvKey = this.$route.params.id.replace(":", "");
            try {
                const response = await axios.get(
                'https://feuerwehr-server.org:5000/aufgabenByQuizID',
                { params: { konvKey: konvKey, quizID: quizID } }
                );
                console.log(response.data);
                //response.data = this.shuffle(response.data);
                return this.shuffle(response.data);
            } catch (err) {
                console.log(err);
                return false;
            }
        },
        async getMoeglichkeiten(quizID, aufgabenID){
            var konvKey = this.$route.params.id.replace(":", "");
            try {
                const response = await axios.get(
                'https://feuerwehr-server.org:5000/moeglichkeitenByAufgabenID',
                { params: { konvKey: konvKey, quizID: quizID, aufgabenID: aufgabenID } }
                );
                console.log(response.data);
                //response.data = this.shuffle(response.data);
                return response.data;
            } catch (err) {
                console.log(err);
                return false;
            }
        },
        shuffle: function (array) {
            let counter = array.length;

            // While there are elements in the array
            while (counter > 0) {
                // Pick a random this.index
                let index = Math.floor(Math.random() * counter);

                // Decrease counter by 1
                counter--;

                // And swap the last element with it
                let temp = array[counter];
                array[counter] = array[index];
                array[index] = temp;
            }

            return array;
        },
        checkAnswer(){
            var falsch = false;
            for (let i = 0; i < this.moeglichkeiten.length; i++) {
                console.log("Test");
                var antwort = this.moeglichkeiten.find(obj => obj.position == i + 1)?.richtigFlag == 1;
                if (document.getElementById("checkbox" + (+i + 1).toString()).checked == antwort) {
                    document.getElementById("Antwort" + (+i + 1).toString()).style.backgroundColor = "green";
                } else {
                    falsch = true;
                    document.getElementById("Antwort" + (+i + 1).toString()).style.backgroundColor = "red";
                }
            }
            if (falsch) {
                this.falscheAntwort++;
            }
            this.buttonAbschickenactive = false;
            this.buttonWeiteractive = true;
        },
        async next(){
            if(this.aktuelleFrage < this.aufgaben.length - 1){
                this.aktuelleFrage++;
                await this.setNewAufgabe(this.quizID);
                this.buttonAbschickenactive = true;
                this.buttonWeiteractive = false;
                this.image = "";
                this.clearFileInput(document.getElementById("Bild"));
                this.image = this.aufgaben[this.aktuelleFrage].imagePath;
                if(this.aenderungsmodus){
                    this.clearFileInput(document.getElementById("Bild"));
                    this.image = "";
                }
            } else{
                if(this.aenderungsmodus){
                    this.firstStart = true;
                    this.aktuelleFrage = 0;
                    await this.startGame();
                } else{
                    await this.showErgebnis();
                }
            }
        },
        async setNewAufgabe(quizID){
            if(!this.aenderungsmodus){
                for (let i = 0; i < this.moeglichkeiten.length; i++) {
                    document.getElementById("Antwort" + (+i + 1).toString()).style.backgroundColor = "white";
                    document.getElementById("checkbox" + (+i + 1).toString()).checked = false;
                }
            }
            if(this.aufgaben[this.aktuelleFrage].imagePath == ""){
                this.imageActive = false;
            } else{
                this.imageActive = true;
            }
            //this.aufgaben = await this.getAufgaben(quizID);
            this.moeglichkeiten = await this.getMoeglichkeiten(quizID, this.aufgaben[this.aktuelleFrage].aufgabenID);
        },
        async showErgebnis(){
            if (this.falscheAntwort == 0) {
                Swal.fire({
                    title: 'fehlerfrei',
                    text: 'Du hast alle ' + this.aufgaben.length.toString() + ' richtig beantwortet.',
                    icon: 'success',
                }).then((result) => {
                    /* Read more about handling dismissals below */
                    if (result.dismiss === Swal.DismissReason.timer) {
                        console.log('I was closed by the timer')
                    }
                })
            } else if (this.falscheAntwort <= 2) {
                Swal.fire({
                    title: 'Naja',
                    text: 'Du hast ' + (+this.aufgaben.length - +this.falscheAntwort).toString() + ' von ' + this.aufgaben.length.toString() + ' richtig beantwortet.',
                    icon: 'warning',
                }).then((result) => {
                    /* Read more about handling dismissals below */
                    if (result.dismiss === Swal.DismissReason.timer) {
                        console.log('I was closed by the timer')
                    }
                })
            } else if (this.falscheAntwort >= 3) {
                Swal.fire({
                    title: 'Übungsbedarf',
                    text: 'Du hast nur ' + (+this.aufgaben.length - +this.falscheAntwort).toString() + ' von ' + this.aufgaben.length.toString() + ' richtig beantwortet.',
                    icon: 'error',
                }).then((result) => {
                    /* Read more about handling dismissals below */
                    if (result.dismiss === Swal.DismissReason.timer) {
                        console.log('I was closed by the timer')
                    }
                })
            }
            this.firstStart = true;
            for (let i = 0; i < this.moeglichkeiten.length; i++) {
                document.getElementById("Antwort" + (+i + 1).toString()).style.backgroundColor = "white";
                document.getElementById("checkbox" + (+i + 1).toString()).checked = false;
            }
            this.buttonAbschickenactive = true;
            this.buttonWeiteractive = false;
            this.aktuelleFrage = 0;
            await this.startGame();
        },
        async startGame(){
            var quizID = await this.getQuizID();
            this.quiz = await this.getQuizByID(quizID);
            if(this.firstStart = true){
                this.firstStart = false;
                this.aufgaben = await this.getAufgaben(quizID);
                this.moeglichkeiten = await this.getMoeglichkeiten(quizID, this.aufgaben[this.aktuelleFrage].aufgabenID);
            }
        }
    },
    async created(){
        await this.startGame();
        if(this.$route.params.id == ':AKSDHGLalsghla9126589'){
            this.settingsAvailable = true;
        }
    }
}
</script>

<style lang="scss">
#quiz{
    display: block !important;
    position:absolute !important;
    height:auto !important;
    bottom:0 !important;
    top:0 !important;
    left:0 !important;
    right:0 !important;
    margin-top: 3.7rem !important;
    padding-left: 1rem;
    padding-right: 1rem;
    height: 72vh;
    overflow-y: scroll;
    background-color: white;
    margin-bottom: 3rem;

    #AenderungsSpan{
        display:flex;
        align-items:center;
        justify-content: center;
        margin-top: 0.7rem !important;
    }

    #moeglichkeitLoeschen{
        margin: 0px !important;
        background-color: #C00000;
        color: white;
        margin-left: 0.7rem !important;
    }

    .buttonSubmitNext{
        //width: 33%;
        height: 2.7rem;
        margin-top: 1rem;
        border: solid rgba(0, 0, 0, 0) 2px;
        border-radius: 8px;
        text-align:center;
        color: white;
        font-size:larger;
    }

    #buttonAbschicken{
        background-color: green;
    }

    #buttonWeiter{
        background-color: gray;
    }

    #buttonSpeichern{
        background-color: blue;
    }

    #buttonWeiterAenderungsmodus{
        background-color: gray;
    }

    #buttonHinzufuegen{
        background-color: green;
    }

    img{
        width: 23%;
    }

    .Settings{
      background-color: transparent !important;
      position: fixed !important;
      top: 0.5rem !important;
      right: 0.5rem !important;
      z-index: 10000 !important;
      padding: 0.5rem !important;
      width: auto !important;
      border: none;

      :hover{
        cursor: pointer;
      }

      h1{
        margin: 0 !important;
        padding: 0 !important;
        color: black;
      }
    }

    #settings{
    width: 75vw;
    max-width: 500px;
    background-color: white !important;
    position: fixed !important;
    top: 2.5rem !important;
    right: 2rem !important;
    z-index: 99999 !important;
    padding: 1rem !important;
    border-radius: 7px !important;
    border: solid grey 1px;

    button{
      width: 100%;
      padding-top: 2px;
      padding-bottom: 2px;
      margin-top: 3px;
      margin-bottom: 3px;
      font-size:medium;
      padding-right: 3px;
      padding-left: 3px;
    }

    .buttonOn{
      background-color: green;
      color: white;
    }

    .buttonOff{
      background-color: #C00000;
      color: white;
    }

    p{
      text-align: left;
      margin: 0;
    }
  }

  hr{
      margin-top: 4px;
    }

.menuButton{
    display: flex;
    justify-content: space-between;
    span{
    margin-left: 1rem;
    margin-right: 1rem;
    font-size: large;
    }
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
    background-color: white;
    border:none;
    //border-top: solid black 1px;
    //font-weight: 300;
}

.menuButton:hover{
    background-color: rgb(223, 223, 223);
}

    @media screen and (max-height: 768px) {
        img{
            width: 90%;
        }
    }
}
</style>
